<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import type { Contact, CustomerTypeEnum } from '~/layers/forms/models'
import { Form } from '~/layers/forms/models'
import { emailValidator, regularExpresionValidator, requiredIfValidator } from '~/utils/validators'

interface Props {
  modelValue: Contact
  customerType?: PropsTypesOf<typeof CustomerTypeEnum>['code'] | null
}

const props = withDefaults(defineProps<Props>(), {
  customerType: null,
})

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)
const { constraints } = useContractConstraints()
const v$ = useValidation(
  () => ({
    email: {
      required: requiredIfValidator(!!constraints.value?.requireEmail),
      email: emailValidator,
    },
    phone: {
      required: requiredIfValidator(!!constraints.value?.requireCelPhone),
      isValid: regularExpresionValidator(
        /^(?<area>[(]8[0 | 2| 4]9[)]) (?<number>\d{3}-\d{4})$/,
        'El número no es valido'
      ),
    },
  }),
  model,
  { $scope: Form.contact, $registerAs: Form.contact }
)
</script>

<template>
  <FormsGlobalContainer :identifier="Form.contact">
    <FormsGlobalTitle
      text="Información de contacto"
      icon-class="icon-[ph--phone-list-bold]"
    />

    <InputField
      label="Correo electrónico"
      :error="v$.email?.$error"
      :error-message="v$.email?.$errors[0]?.$message.toString()"
    >
      <InputAddon :prefix="{ IconClass: 'icon-[ph--at-bold]' }">
        <PvInputText v-model.lowercase="model.email" />
      </InputAddon>
    </InputField>

    <InputField
      label="Teléfono"
      :error="v$.phone?.$error"
      :error-message="v$.phone?.$errors[0]?.$message.toString()"
    >
      <InputAddon :prefix="{ IconClass: 'icon-[ph--phone-bold]' }">
        <PvInputMask
          v-model="model.phone"
          mask="(999) 999-9999"
        />
      </InputAddon>
    </InputField>
  </FormsGlobalContainer>
</template>
